"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _uiKit = require("@devsta/ui-kit");

require("./styles/_available-library-selector.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var buildOptions = (0, _memoizeOne.default)(function (organisationMemberships) {
  return organisationMemberships.map(function (membership) {
    return {
      value: membership.organisation.organisationId,
      label: membership.organisation.name
    };
  });
});
var getDefaultValue = (0, _memoizeOne.default)(function (selectedInspirationOrgId, organisationMemberships) {
  return organisationMemberships.find(function (membership) {
    return membership.organisation.organisationId === selectedInspirationOrgId;
  });
});

var AvailableLibrarySelector = function AvailableLibrarySelector(props) {
  var organisationMemberships = props.organisationMemberships,
      setSelectedOrgId = props.setSelectedOrgId,
      selectedInspirationOrgId = props.selectedInspirationOrgId;
  var options = buildOptions(organisationMemberships);
  var selectedDefaultValue = getDefaultValue(selectedInspirationOrgId, organisationMemberships);

  var setAvailableLibrary = function setAvailableLibrary(membership) {
    setSelectedOrgId(membership.value);
  };

  return _react.default.createElement("div", {
    className: "select-available-library"
  }, _react.default.createElement(_uiKit.Dropdown, {
    id: "select-available-library",
    label: "Available libraries",
    className: "select-available-library__container",
    onChange: setAvailableLibrary,
    defaultValue: {
      value: selectedDefaultValue.organisation.organisationId,
      label: selectedDefaultValue.organisation.name
    },
    value: {
      value: selectedDefaultValue.organisation.organisationId,
      label: selectedDefaultValue.organisation.name
    },
    options: options,
    type: "BUTTON"
  }));
};

var _default = (0, _react.memo)(AvailableLibrarySelector);

exports.default = _default;